import axios from 'axios'
import { API_BASE } from '../config'

function authHeaders() {
    return { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
}

export default class Cards {
    // GET /cards - The full card set and pack rules, with packPrice: what a booster pack costs in Clomp Coins
    getCatalog() {
        return axios.get(`${API_BASE}/cards`).then(x => x.data);
    }

    // GET /cards/me - The logged-in user's collection ({ cardID: count }), pack stock, waiting free packs and Clomp
    // Coins (coins)
    getMine() {
        return axios.get(`${API_BASE}/cards/me`, authHeaders()).then(x => x.data);
    }

    // POST /cards/open - Buy and open a pack from a card set, for the pack price in Clomp Coins: returns the cards,
    // which of them are new, the pack stock afterwards and the coins left (coins). Without enough coins the refusal
    // (409) carries { message, coins, packPrice }
    openPack(setID) {
        return axios.post(`${API_BASE}/cards/open`, { set: setID }, authHeaders()).then(x => x.data);
    }

    // POST /cards/free - Open a free pack ('daily' or 'weekly'): returns the cards, which of them are new, and which
    // free packs are still waiting
    openFreePack(packID) {
        return axios.post(`${API_BASE}/cards/free`, { pack: packID }, authHeaders()).then(x => x.data);
    }

}
